import { ReactElement } from 'react';

import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { StyledFlex } from '@dreryk/react-components';
import { FormContextValues, Translate, useFormController } from '@dreryk/react-common';

import { patientMedicalInformationTranslationKeys } from '../../translations';

import { MedicalInformationAttachmentMarkAsRemovedFormBean } from './MedicalInformationAttachmentMarkAsRemovedForm.types';
import { MedicalInformationAttachmentMarkAsRemovedFormReasonField } from './MedicalInformationAttachmentMarkAsRemovedFormReasonField';
import { MedicalInformationAttachmentMarkAsRemovedFormDescriptionField } from './MedicalInformationAttachmentMarkAsRemovedFormDescriptionField';

export type MedicalInformationAttachmentMarkAsRemovedFormRendererProps = Pick<
   FormContextValues<MedicalInformationAttachmentMarkAsRemovedFormBean>,
   'handleSubmit' | 'formState'
>;

type MedicalInformationAttachmentRemoveModalProps = Pick<MedicalInformationAttachment, 'id'> & {
   children: (rendererProps: MedicalInformationAttachmentMarkAsRemovedFormRendererProps) => ReactElement;
};

export const MedicalInformationAttachmentMarkAsRemovedForm = (
   props: MedicalInformationAttachmentRemoveModalProps
): ReactElement => {
   const {
      register,
      watch,
      handleSubmit,
      formState,
   } = useFormController<MedicalInformationAttachmentMarkAsRemovedFormBean>({
      reason: 'MISTAKE',
   });
   return (
      <StyledFlex direction={'column'} gap={24}>
         <Translate>
            {patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.info}
         </Translate>
         <StyledFlex direction={'column'} gap={8}>
            <MedicalInformationAttachmentMarkAsRemovedFormReasonField register={register} />
            <MedicalInformationAttachmentMarkAsRemovedFormDescriptionField register={register} watch={watch} />
         </StyledFlex>
         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </StyledFlex>
   );
};
